// // Pages/LoginScreen.jsx

// import React, { useState } from "react";
// import "./LoginScreen.css";
// import { useNavigate } from "react-router-dom";
// import logo from "../src/Components/Icon.png";

// const LoginScreen = () => {
//   const navigate = useNavigate();

//   const [loginScreenFormData, setLoginScreenFormData] = useState({
//     email: "",
//     password: "",
//   });

//   const handleLoginScreenChange = (e) => {
//     setLoginScreenFormData({
//       ...loginScreenFormData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleLoginScreenSubmit = (e) => {
//     e.preventDefault();

//     // Login logic here

//     navigate("/dashboard");
//   };

//   return (
//     <div className="loginscreen-container">
//       <div className="loginscreen-card">
//         <div className="loginscreen-logo-wrapper">
//           <img src={logo} alt="logo" className="loginscreen-logo" />
//         </div>
//         <h2 className="loginscreen-title">Login</h2>

//         <p className="loginscreen-subtitle">Enter your email and password</p>

//         <form className="loginscreen-form" onSubmit={handleLoginScreenSubmit}>
//           <div className="loginscreen-input-group">
//             <label className="loginscreen-label">Email</label>

//             <input
//               type="email"
//               name="email"
//               placeholder="Enter your email"
//               value={loginScreenFormData.email}
//               onChange={handleLoginScreenChange}
//               className="loginscreen-input"
//               required
//             />
//           </div>

//           <div className="loginscreen-input-group">
//             <label className="loginscreen-label">Password</label>

//             <input
//               type="password"
//               name="password"
//               placeholder="Enter your password"
//               value={loginScreenFormData.password}
//               onChange={handleLoginScreenChange}
//               className="loginscreen-input"
//               required
//             />
//           </div>

//           <button type="submit" className="loginscreen-btn">
//             Login
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default LoginScreen;



// Pages/LoginScreen.jsx

import React, { useState } from "react";
import "./LoginScreen.css";
import { useNavigate } from "react-router-dom";
import logo from "../src/Components/Icon.png";
import API_BASE from "../src/config";

const LoginScreen = () => {
  const navigate = useNavigate();

  const [loginScreenFormData, setLoginScreenFormData] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  const handleLoginScreenChange = (e) => {
    setLoginScreenFormData({
      ...loginScreenFormData,
      [e.target.name]: e.target.value,
    });
  };

  const handleLoginScreenSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      setError("");

      const response = await fetch(
        `${API_BASE}/admin-auth/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(loginScreenFormData),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Login failed");
      }

      const data = await response.json();

      // Store token
      sessionStorage.setItem("token", data.token);

      // OPTIONAL
      // Store other details if your API returns them
      sessionStorage.setItem("adminId", data.adminId || "");
      sessionStorage.setItem("adminEmail", data.email || "");
      sessionStorage.setItem("adminName", data.name || "");
      sessionStorage.setItem("adminRole", data.role || "");

      navigate("/dashboard");
    } catch (err) {
      console.error(err);

      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="loginscreen-container">
      <div className="loginscreen-card">
        <div className="loginscreen-logo-wrapper">
          <img src={logo} alt="logo" className="loginscreen-logo" />
        </div>

        <h2 className="loginscreen-title">Login</h2>

        <p className="loginscreen-subtitle">
          Enter your email and password
        </p>

        <form
          className="loginscreen-form"
          onSubmit={handleLoginScreenSubmit}
        >
          <div className="loginscreen-input-group">
            <label className="loginscreen-label">
              Email
            </label>

            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              value={loginScreenFormData.email}
              onChange={handleLoginScreenChange}
              className="loginscreen-input"
              required
            />
          </div>

          <div className="loginscreen-input-group">
            <label className="loginscreen-label">
              Password
            </label>

            <input
              type="password"
              name="password"
              placeholder="Enter your password"
              value={loginScreenFormData.password}
              onChange={handleLoginScreenChange}
              className="loginscreen-input"
              required
            />
          </div>

          {error && (
            <p
              style={{
                color: "red",
                fontSize: "14px",
                marginBottom: "10px",
              }}
            >
              {error}
            </p>
          )}

          <button
            type="submit"
            className="loginscreen-btn"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginScreen;